import React from 'react';
import ChatContent from './ChatContent';

const initials = (n = '') =>
    n.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);

const ChatSidePanel = ({ data, onClose }) => {
    if (!data) return null;

    const name = data.creative_name || data.brand || '?';
    const sub = data.ad_creative_sub_type || data.adType || '';

    return (
        <div className="flex flex-col h-full">
            <div className="flex items-center justify-between px-4 py-3 bg-[#075E54] text-white flex-shrink-0">
                <div className="flex items-center gap-3 flex-1 min-w-0">
                    <div className="w-10 h-10 rounded-full bg-[#128C7E] flex items-center justify-center text-base font-bold flex-shrink-0">
                        {initials(name)}
                    </div>
                    <div className="flex-1 min-w-0">
                        <h4 className="font-semibold text-2xl leading-tight break-words">{name}</h4>
                        {sub && <p className="text-sm text-green-200 break-words">{sub}</p>}
                    </div>
                </div>
                <button
                    onClick={onClose}
                    className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/20 transition-colors text-white text-lg flex-shrink-0 ml-2"
                    title="Close chat"
                >
                    ✕
                </button>
            </div>
            <div className="flex-1 min-h-0 flex flex-col">
                <ChatContent data={data} />
            </div>
        </div>
    );
};

export default ChatSidePanel;
